export default class CommonApi {
  constructor(store) {
    this.store = store;
  }

  /**
   * paas SDK透传过来的数据
   *
   * @param {*} data
   * @memberof CommonApi
   */
  passThrough(data) {
    const { userId, docId } = data;
    let passThrough = {
      userId,
      docId
    };

    this.store.setKV('passThrough', passThrough);
  }

  getPaasThrough() {
    return this.store.getKV('passThrough');
  }

  isMobileSDK(val) {
    this.store.setKV('isMobileSDK', val);
  }
}
